export default __webpack_public_path__ + "logo_white.05bf1bd8.png";